import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import AddressesReducer from './reducers/addresses-reducer';
import AppReducer from './reducers/app-reducer';
import AuthReducer from './reducers/auth-reducer';
import BasketReducer from './reducers/basket-reducer';
import RecommendationsReducer from './reducers/recommendations-reducer';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  middleware: (defaultMiddleware) => defaultMiddleware().concat(sagaMiddleware),
  reducer: {
    auth: AuthReducer,
    basket: BasketReducer,
    addresses: AddressesReducer,
    app: AppReducer,
    recommendations: RecommendationsReducer
  }
});

sagaMiddleware.run(rootSaga);

export type IRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
